module.exports = __webpack_public_path__ + "static/media/Arch--pink.009ec454.svg";